import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from "../../components/header/header.component";

@Component({
  selector: 'app-terms',
  imports: [
    TranslatePipe,
    HeaderComponent
],
  templateUrl: './terms.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './terms.component.scss'
})
export class TermsComponent {

  back(){
    history.back();
  }

}
